import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroApiPaths } from '../ApiPaths/KhodroApiPaths';
import { IGetBimehNamehShakhSalesPrintQuery } from '../SakhsSalesBimehNameh/Queries/IGetBimehNamehShakhSalesPrintQuery';
import { KhodroHttpGetService } from '../Services/KhodroHttpService';

const printBimehNamehShakhsSales = createAsyncThunk(
  'ShakhSalesBimehNamehPrint/printBimehNamehShakhsSales',
  async (query: IGetBimehNamehShakhSalesPrintQuery) => {
    return await KhodroHttpGetService({
      url: `${KhodroApiPaths.BimehNamehHayeShakhsSales.PrintBimehNamehShakhsSales}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);

export default printBimehNamehShakhsSales;
